module.exports = __webpack_public_path__ + "img/智能写作.2977423a.jpg";